import { render, staticRenderFns } from "./admin_multi_lang_links.vue?vue&type=template&id=4f9b2df2&scoped=true"
import script from "./admin_multi_lang_links.vue?vue&type=script&lang=js"
export * from "./admin_multi_lang_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b2df2",
  null
  
)

export default component.exports